export default "__VITE_ASSET__BB7orun0__"